import React, { useEffect, useState } from "react";
import { gql } from "@apollo/client";
import Spinner from "react-bootstrap/Spinner";

import NotificationIcon from "./NotificationIcon/NotificationIcon";
import { connect } from "react-redux";
import { mapDispatchToProps, mapStateToProps } from "../../common/UserDataReducer";
import { apolloClient } from "../..";
import { useLocation } from "react-router-dom";

// GET
export const GET_ALL_NOTIFICATIONS = gql`
  query {
    myNotification {
      __typename
      id
      isRead
      createdTs
      action {
        name
      }
      folder {
        title
        id
        isRoot
        isArchive
        inTrash
        parentFolder {
          id
        }
      }
      tag {
        id
        name
      }
      typeOfDocument {
        id
        title
      }
      createdBy {
        username
        firstName
        lastName
        profile {
          image
          role {
            name
          }
        }
      }
    }
  }
`;

const totalUnread = (data) => {
  let count = 0;
  data.map((item) => (item.isRead ? null : (count = count + 1)));
  return count;
};

const Notification = (props) => {
  let [notifications, setNotifications] = useState(props.notifications);
  let [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // GET ALL TEMPLATE
    //@TODO:  Uncomment this
    apolloClient
      .query({
        query: gql`
          ${GET_ALL_NOTIFICATIONS}
        `,
        variables: {},
      })
      .then((result) => {
        let notifications = result.data.myNotification.filter(
          (notification) => notification["__typename"] === "NotificationType"
        );
        setNotifications(notifications);
        setLoading(false);
        props.updateNotification({ notifications });
      })
      .catch((e) => {
        setLoading(false);
        if (e.message === "User is disabled") {
          window.location.href = "/login";
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return loading ? (
    <div className="notification-progress-icon">
      <Spinner animation="border" role="status" />
    </div>
  ) : (
    <div>
      <NotificationIcon
        notifications={notifications}
        unReadCount={totalUnread(notifications)}
      />
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
